import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../services/theme.service';
import { LanguageService } from '../../services/language.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  @Output() menuToggle = new EventEmitter<void>();
  showUserMenu = false;
  currentLang: 'en' | 'ar' = 'en';

  constructor(public theme: ThemeService, private router: Router, public langService: LanguageService) {
    this.currentLang = this.langService.current;
    this.langService.lang$.subscribe(lang => { this.currentLang = lang; });
  }

  toggleLang(): void {
    this.langService.toggle();
    this.currentLang = this.langService.current;
  }

  toggleUserMenu() {
    this.showUserMenu = !this.showUserMenu;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.user-chip-wrap')) {
      this.showUserMenu = false;
    }
  }

  logout() {
    localStorage.removeItem('access_token');
    this.router.navigate(['/login']);
  }
}
